import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Card, Row, Table, Button } from "antd";

import Box from "../components/Box";
import Text from "../components/Text";

import DetailLabel from "../components/DetailLabel";

import axios from "../utils/axios";
import { blockUrl, txUrl } from "../utils/urls";

const BlockDetail = () => {
  const navigate = useNavigate();

  const { blockHeight } = useParams();

  const [lastBlock, setLastBlock] = useState({});
  const [block, setBlock] = useState(null);
  const [transactions, setTransactions] = useState([]);

  const fetchLastBlock = async () => {
    const url = `${blockUrl}/last`;
    axios.get(url).then((response) => {
      if (response.data) {
        setLastBlock(response.data);
      }
    });
  };

  const fetchBlock = async (blockHeight) => {
    const url = `${blockUrl}/height/${blockHeight}`;
    axios
      .get(url)
      .then((response) => {
        if (response.data) {
          setBlock(response.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const fetchTransaction = async (txHash) => {
    const url = `${txUrl}/${txHash}`;
    axios.get(url).then((response) => {
      if (response.data) {
        setTransactions((prev) => [...prev, response.data]);
      }
    });
  };

  useEffect(() => {
    fetchLastBlock();
  }, []);

  useEffect(() => {
    fetchBlock(blockHeight);
  }, [blockHeight]);

  useEffect(() => {
    if (block) {
      block.tx_hashes.forEach((tx) => {
        fetchTransaction(tx.hash_id);
      });
    }
  }, [block]);

  const renderDetail = () => {
    return (
      <Box>
        <Row>
          <Text fontSize={24} fontWeight={600}>
            Block Info
          </Text>
        </Row>
        <DetailLabel
          label="Chain ID"
          value={lastBlock?.header?.chain_id ?? "-"}
        />
        <DetailLabel label="Height" value={block?.header?.height ?? "-"} />
        <DetailLabel label="Hash" value={block?.block_id ?? "-"} />
        <DetailLabel label="Block Time" value={block?.header?.time ?? "-"} />
        <DetailLabel
          label="Proposer"
          value={block?.header?.proposer_address ?? "-"}
        />
        <DetailLabel label="Tx Count" value={block?.tx_hashes?.length ?? "-"} />
      </Box>
    );
  };

  const renderTransactions = () => {
    const columns = [
      {
        title: "Tx hash",
        render(record) {
          return (
            <Button type="link" onClick={() => navigate(`/tx/${record.hash}`)}>
              {record.hash}
            </Button>
          );
        },
      },
      {
        title: "Type",
        render: (record) => {
          return <Box>{record.tx_type}</Box>;
        },
      },
    ];

    return (
      <Box marginTop="24px">
        <Table dataSource={transactions} columns={columns} pagination={false} />
      </Box>
    );
  };

  return (
    <Card>
      {renderDetail()}
      <Box padding="36px">
        <Card>{renderTransactions()}</Card>
      </Box>
    </Card>
  );
};

export default BlockDetail;
